import styled from "styled-components";

export const DashboardContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  position: relative;
`;

export const DashboardTitle = styled.h3`
  color: #203b34;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
`;

export const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0 50px;
`;

export const SliderWrapper = styled.div`
  display: flex;
  gap: 20px;
  transition: ${({ $isDragging }) =>
    $isDragging ? "none" : "transform 0.3s ease-in-out"};
  transform: translateX(${({ $offset }) => $offset}px);
  cursor: ${({ $isDragging }) => ($isDragging ? "grabbing" : "grab")};
  user-select: none;
`;

export const UsersGrid = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
`;

export const UserCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
  border-radius: 8px;
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s, box-shadow 0.2s;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  flex-shrink: 0;
  cursor: ${({ $isDragging }) => ($isDragging ? "grabbing" : "pointer")};
  pointer-events: ${({ $isDragging }) => ($isDragging ? "none" : "auto")};

  &:hover {
    transform: ${({ $isDragging }) =>
      $isDragging ? "none" : "translateY(-2px)"};
    box-shadow: ${({ $isDragging }) =>
      $isDragging
        ? "0 2px 8px rgba(0, 0, 0, 0.1)"
        : "0 4px 12px rgba(0, 0, 0, 0.15)"};
  }
`;

export const SliderButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ $direction }) =>
    $direction === "left" ? "left: 10px;" : "right: 10px;"}
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: #203b34;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s;
  opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  &:hover {
    background-color: #2d5347;
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }
`;

export const UserName = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #203b34;
  text-align: center;
  word-wrap: break-word;
  word-break: break-word;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  line-height: 1.2;
  overflow: hidden;
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 180px;
  position: relative;
`;

export const ProgressBar = styled.div`
  width: 35px;
  height: 100%;
  background-color: #e9e9e9;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
`;

export const ProgressSegment = styled.div`
  width: 100%;
  height: ${({ $height }) => $height}%;
  background-color: ${({ $color }) => $color};
  position: relative;
  transition: height 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SegmentIcon = styled.i`
  color: #fff;
  font-size: 0.65rem;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
`;

export const StatusLabel = styled.div`
  font-size: 0.7rem;
  color: #666;
  text-align: center;
  margin-top: 8px;
  font-weight: 500;
  height: 40px;
  line-height: 16px;
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
`;

export const SliderInfo = styled.div`
  text-align: center;
  margin-top: 15px;
  font-size: 0.85rem;
  color: #666;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: #555;
`;

export const LegendIcon = styled.i`
  color: ${({ $color }) => $color};
  font-size: 0.85rem;
`;

export const LegendColor = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${({ $color }) => $color};
  border-radius: 4px;
`;

export const LegendLabel = styled.span`
  font-weight: 500;
`;

export const ContextMenu = styled.div`
  position: fixed;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 8px 0;
  z-index: 1000;
  min-width: 180px;
  border: 1px solid #e0e0e0;
  animation: fadeIn 0.15s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ContextMenuItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-size: 0.875rem;
  color: #203b34;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    background-color: ${({ $color }) => `${$color}15` || "#f5f5f5"};
    color: ${({ $color }) => $color || "#203b34"};

    i {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: scale(0.98);
  }

  i {
    width: 18px;
    font-size: 1rem;
    color: ${({ $color }) => $color || "#203b34"};
    transition: transform 0.2s ease;
  }

  span {
    flex: 1;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

export const ContextMenuDivider = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 4px 0;
`;
